import { colors as baseColors } from 'chameleonjs';
import createColorPalette from '@vitalsource/vstui/colors/createColorPalette';

/**
 * We need to keep this for app parity for now
 */
const jrLegacyGold = createColorPalette([
  null,
  '#FFF2D3',
  '#FFE29C',
  '#FFD560',
  '#FFCC33',
  '#E8B520',
  '#BE8A0D',
  '#9A6F07',
  '#855F07',
  '#715005',
  '#5A4206',
]);

const vstuiColors = {
  ...baseColors,
  jrLegacyGold,
};

export default vstuiColors;
